// extracted by mini-css-extract-plugin
module.exports = {"container":"LinkAws__container___aI0K+"};